// extracted by mini-css-extract-plugin
module.exports = {"leaseRadarCell":"LeaseRadar_leaseRadarCell__2H0tu","details":"LeaseRadar_details__NogtE","adminSelect":"LeaseRadar_adminSelect___ihOi"};